import { gql } from 'graphql-tag';

export const GET_AVAILABLE_ATTRIBUTES_AND_METRICS = gql`
  query getAvailableAttributesAndMetrics($domain: String!) {
    getAvailableAttributes(domain: $domain) {
      id
      valueType
      values
      attributeGroup
      sqlColumn
      name
      description
      cardinality
      attributeSubGroups
      classification
      tags
      isActive
    }
    getAvailableMetrics(domain: $domain) {
      id
      name
      description
      valueType
      ownedBy
      calculation
      datasourceIds
      subcategories
      metricColumns
      isActive
      columnsByPeriodType {
        Intraday
        Daily
        Weekly
        Monthly
        Quarterly
        Yearly
        Ytd
        Ttm
        T3m
        T6m
        Py
        Pm
        Pq
      }
      classification
      tags
      intradaySql
      dailySql
      weeklySql
      monthlySql
      quarterlySql
      yearlySql
      ttmSql
      t3mSql
      t6mSql
      ytdSql
      pySql
      pmSql
      pqSql
    }
  }
`;

export const GET_REPORT_ODM = gql`
  query getOdmForReport($query: ReportOdmQuery!) {
    getOdmForReport(query: $query) {
      site
      metric
      timespan
    }
  }
`;

export const USERS_FAVORITE_REPORTS = gql`
  query usersFavoriteReports {
    usersFavoriteReports
  }
`;

export const GET_REPORT_TEMPLATES_IN_REPORT_GROUP = gql`
  query getReportTemplatesInReportGroup($reportGroupId: String!) {
    getReportTemplatesInReportGroup(reportGroupId: $reportGroupId) {
      id
      name
      domain
      version
      filtersV2
      selectedGroupingAttributeIds
    }
  }
`;

export const GET_REPORT_TEMPLATES_BY_IDS = gql`
  query getReportTemplatesByIds($reportTemplateIds: [String]!) {
    getReportTemplatesByIds(reportTemplateIds: $reportTemplateIds) {
      id
      name
      domain
      version
      filtersV2
      selectedGroupingAttributeIds
      reportType
    }
  }
`;

export const GET_FULL_REPORT_TEMPLATES_BY_IDS = gql`
  query getReportTemplatesByIds($reportTemplateIds: [String]!) {
    getReportTemplatesByIds(reportTemplateIds: $reportTemplateIds) {
      id
      name
      displayStyle
      reportType
      selectedTimespans {
        duration
        durationType
        expression
        periodType
        type
        temporalAdjusters {
          function
          arguments
        }
        comparisons {
          comparison
          comparisonType
        }
        isSparkchartActive
      }
      selectedGroupingAttributeIds
      selectedMetricIds
      filters {
        attributeId
        operator
        values
      }
      filtersV2
      hierarchyName
    }
  }
`;
